import { assertNumber } from '../helpers/assertFunctions';
export function groupArray(arr, num) {
    assertNumber(num);
    if (!arr || !arr.length)
        return [[]];
    if (arr.length < num)
        return [arr];
    var group = Math.ceil(arr.length / num);
    var ret = [];
    for (var i = 0; i < group; i++) {
        ret.push(arr.slice(i * num, i * num + num));
    }
    return ret;
}
